import React, { useEffect, useState } from "react";
import { useAuth } from "@/auth/AuthContext";

export function ExamSecurityWrapper({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const [timestamp, setTimestamp] = useState("");

  useEffect(() => {
    const updateTime = () => setTimestamp(new Date().toLocaleString());
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && ["c", "a", "p", "x"].includes(e.key.toLowerCase())) {
        e.preventDefault();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleContextMenu = (e: React.MouseEvent) => e.preventDefault();
  const handleCopy = (e: React.ClipboardEvent) => e.preventDefault();
  const handleCut = (e: React.ClipboardEvent) => e.preventDefault();
  const handleDragStart = (e: React.DragEvent) => e.preventDefault();

  const watermarkText = `${user?.email || "Student"} • ${timestamp}`;

  return (
    <div
      translate="no"
      className="notranslate select-none relative w-full h-full flex flex-col"
      onContextMenu={handleContextMenu}
      onCopy={handleCopy}
      onCut={handleCut}
      onDragStart={handleDragStart}
    >
      {/* Watermark Overlay (Removed as requested) */}

      {children}
    </div>
  );
}
